var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company__info__container" },
    [
      _c("Card", _vm._b({}, "Card", _vm.options, false), [
        _c("div", { staticClass: "card__container" }, [
          _c("div", { staticClass: "logo__section" }, [
            _c("label", { staticClass: "logo__upload" }, [
              _vm.data.company_logo.src
                ? _c("img", {
                    attrs: {
                      src: _vm.data.company_logo.src,
                      alt: _vm.data.company_logo.alt,
                      srcset: ""
                    }
                  })
                : _c("span", [_vm._v(_vm._s(_vm.data.company_logo.text))]),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "file", name: "logo", hidden: "", id: "logo" },
                on: { change: _vm.upload }
              })
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "info__description",
              domProps: {
                innerHTML: _vm._s(_vm.data.company_logo.info_description)
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__section" }, [
            _c("span", [_vm._v(_vm._s(_vm.data.form.title))]),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.save.apply(null, arguments)
                  }
                }
              },
              [
                _vm._l(_vm.data.form.elements, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "field__container",
                      style: "width:" + item.width
                    },
                    [
                      _c(
                        item.component,
                        _vm._b(
                          {
                            tag: "components",
                            model: {
                              value: _vm.company[item.name],
                              callback: function($$v) {
                                _vm.$set(_vm.company, item.name, $$v)
                              },
                              expression: "company[item.name]"
                            }
                          },
                          "components",
                          Object.assign(item, { width: null }),
                          false
                        )
                      )
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form_btns" },
                  [
                    _c(
                      "Button",
                      _vm._b({}, "Button", _vm.data.form.submit_btn, false)
                    )
                  ],
                  1
                )
              ],
              2
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e2534f9", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e2534f9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user_profile/company/companyInfo.vue
// module id = null
// module chunks = 